import { get, post, put } from '@/api/apiService.ts';
import type {
  AdminUserRole,
  AdminUserSummary,
  ChangeUserCompanyRequest,
  CreateManagerRequest,
  ManagerSummary,
  ResetSalespersonStatsParams,
  ResetSalespersonStatsResponse,
} from '@/types/admin.ts';
import type { User } from '@/types/auth.ts';

const adminService = {
  listManagers(): Promise<ManagerSummary[]> {
    return get<ManagerSummary[]>('/api/admin/managers');
  },

  createManager(data: CreateManagerRequest): Promise<User> {
    return post<CreateManagerRequest, User>('/api/admin/managers', data);
  },

  changeUserCompany(userId: string, data: ChangeUserCompanyRequest): Promise<User> {
    return put<ChangeUserCompanyRequest, User>(`/api/admin/users/${userId}/company`, data);
  },

  listUsers(role?: AdminUserRole): Promise<AdminUserSummary[]> {
    const qs = role ? `?role=${role}` : '';
    return get<AdminUserSummary[]>(`/api/admin/users${qs}`);
  },

  resetSalespersonStats(
    userId: string,
    params: ResetSalespersonStatsParams = {},
  ): Promise<ResetSalespersonStatsResponse> {
    const search = new URLSearchParams();
    if (params.baseScore !== undefined) search.set('baseScore', String(params.baseScore));
    if (params.sessionCount !== undefined) search.set('sessionCount', String(params.sessionCount));
    const qs = search.toString();
    const url = `/api/admin/users/${userId}/reset-stats${qs ? `?${qs}` : ''}`;
    return post<undefined, ResetSalespersonStatsResponse>(url, undefined as unknown as undefined);
  },
};

export default adminService;
